import React from 'react';

/**
 * CategoryFilter - Dropdown for tab-specific category filtering.
 */
const CategoryFilter = ({ value, options, label, onChange }) => {
    if (!options || options.length === 0) return null;

    return (
        <div className="sd-category-filter">
            <span className="sd-category-filter__label">{label}:</span>
            <select
                value={value || 'all'}
                onChange={(e) => onChange(e.target.value)}
                className="sd-category-filter__select"
            >
                <option value="all">All</option>
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CategoryFilter;
